const isDev = process.env.NODE_ENV === 'development'

const isStaging = process.env.NODE_ENV === 'staging'

let DEFAULT_CONFIG = {
  LOGIN_PERSON_INFO_URL: 'https://cdn.static.igoldhorse.cn/static_pages/login_person_info.html',
  LOGIN_APPLICATION_URL: 'https://cdn.static.igoldhorse.cn/static_pages/login_application.html',
  LOGIN_DISCLAIMER_URL: 'https://cdn.static.igoldhorse.cn/static_pages/login_disclaimer.html',
  LOGIN_PRIVACY_URL: 'https://cdn.static.igoldhorse.cn/static_pages/login_privacy.html',
  LOGIN_ELECTRONIC_TRANSACTION_URL: 'https://cdn.static.igoldhorse.cn/static_pages/electronic_transaction.html'
}

if (isDev || isStaging) {
  DEFAULT_CONFIG = {
    LOGIN_PERSON_INFO_URL: 'https://static.fwdev.ltd/static_pages/login_person_info.html',
    LOGIN_APPLICATION_URL: 'https://static.fwdev.ltd/static_pages/login_application.html',
    LOGIN_DISCLAIMER_URL: 'https://static.fwdev.ltd/static_pages/login_disclaimer.html',
    LOGIN_PRIVACY_URL: 'https://static.fwdev.ltd/static_pages/login_privacy.html',
    LOGIN_ELECTRONIC_TRANSACTION_URL: 'https://static.fwdev.ltd/static_pages/electronic_transaction.html'
  }
}

export default DEFAULT_CONFIG
